import CreatorBaseController from './creator_base_controller';

export default class extends CreatorBaseController {
  static values = {
    surveyableType: String,
    surveyableId: String,
    mode: String
  }

  connect() {
    super.connect();

    this.creator = this.initializeCreator(this.modeValue);

    this.creator.render("survey-creator");

    this.creator.saveSurveyFunc = (saveNo, callback) => {
      // If you use a web service:
      this.saveSurveyData(
        this.creator.JSON,
        saveNo,
        callback
      );
    };
    // Load existing survey if an ID is provided
    if (this.hasSurveyableIdValue) {

      this.creator.readOnly = true;
      this.loadSurvey();
    }
  }

  disconnect() {
    if (this.creator && this.modeValue === 'preview') {
      const testPlugin = this.creator.getPlugin("test");
      if (testPlugin && testPlugin.model && testPlugin.model.simulator) {
        const simulator = testPlugin.model.simulator;
        this.setCookie("surveyPreviewDevice", simulator.activeDevice);
        this.setCookie("surveyPreviewOrientation", simulator.landscape ? "landscape" : "portrait");
      }
    }
  }

  loadSurvey() {
    // load existing survey from the api if it exists
    fetch(`/api/v1/surveys/creators/surveys.json?surveyable_id=${this.surveyableIdValue}&surveyable_type=${this.surveyableTypeValue}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
      .then(response => {
        if (!response.ok) throw new Error("Failed to fetch survey");
        return response.json();
      })
      .then(data => {
        this.creator.JSON = data.survey;
        this.creator.readOnly = false; // Enable builder after loading
      })
      .catch(error => {
        console.error("Error loading survey:", error);
        this.creator.readOnly = false; // Enable builder even if error
      });
  }

  // If you use a web service:
  saveSurveyData(json, saveNo, callback) {
    fetch(`/api/v1/surveys/creators/survey.json?surveyable_id=${this.surveyableIdValue}&surveyable_type=${this.surveyableTypeValue}`, {
      method: 'PUT', // Use PUT for updating an existing survey
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ survey: json }),
    })
      .then(response => {
        if (response.ok) {
          callback(saveNo, true);
        } else {
          callback(saveNo, false);
        }
      })
      .catch(error => {
        callback(saveNo, false);
      });
  }
}
